import { IonButtons, IonGrid,IonContent, IonHeader,IonIcon, IonMenuButton, IonPage, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { calendarOutline   } from 'ionicons/icons';
import './Page.css';

const Autores = () => {

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>Autores</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen className="IonPadding">
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">Autores</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">

                <IonRow className="mt2 mx2 mb2 f2" >
                    Árbol de decisión para el tratamiento farmacológico de la insuficiencia cardiaca crónica con fracción de eyección &lt;50%
        </IonRow>


                <IonRow className="m2 mx2" >
                    <IonText>Adán Gil F (+)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Aranbarri Osoro I (+)</IonText>
                    </IonRow>
                <IonRow className="mb1 mx2">

                    <IonText> Barrot de la Puente J (+)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Cebrián-Cuenca A (+)</IonText>
                    </IonRow>
                <IonRow className="mb1 mx2">

                    <IonText> Franch-Nadal J (+)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Gracia García O (++)</IonText>

                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Pardo Franco J (+)</IonText>
                    </IonRow>
                <IonRow className="mb1 mx2">

                    <IonText> Ruiz Quintero M (+)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2">
                    <IonText> Valle Muñoz A (+++)</IonText>
                </IonRow>
                <IonRow className="mb1 mx2 f1">
                    <IonText>(+) Red de Grupos de estudios de la Diabetes en atención Primaria de la Salud. (redGDPS) </IonText>
                </IonRow>
                <IonRow className="mb1 mx2 f1">
                    <IonText>(++) Servicio de Nefrología. Hospital Universitario Miguel Servet. Zaragoza. </IonText>
                </IonRow>
                <IonRow className="mb1 mx2 f1">
                    <IonText>(+++) Servicio de Cardiología. Hospital Marina Salud. Dénia (Alicante).</IonText>

                </IonRow>

              <IonRow className="mt2 mx2 mb2 ">
              <IonIcon icon={calendarOutline} ></IonIcon><IonText> Publicado: Enero 2022 · Actualizado: Enero 2022</IonText>
        </IonRow>
        <IonRow className="mt2 mb2 mx2 ">
        <IonText>DOI: https://doi.org/10.52102/arbolttoicfe</IonText>
        </IonRow>
        </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default Autores;
